export default __webpack_public_path__ + "static/media/icon-treatment-plan.326a65e9.svg";